import { gql } from '@apollo/client';

export default gql`
  query GetFeatureCosts {
    featureCreditCosts {
      aiChatTutor {
        cost
      }
      remix {
        cost
      }
    }
  }
`;
